module.exports = "<div class=\"stat\" *ngFor=\"let stat of data\">\n  <div class=\"header\">\n    <h3>{{ stat.title }}</h3>\n    <p class=\"value\">{{ stat.value }} <span class=\"unit\">{{ stat.unit }}</span></p>\n  </div>\n  <div class=\"detail\">\n    <p><span class=\"success\">{{ stat.shots.success }}</span> <span class=\"total\">/ {{ stat.shots.total }}</span></p>\n    <p><span class=\"accuracy color {{ getAccuracyColorClass(stat.shots.accuracy) }}\"></span>{{ stat.shots.accuracy }} %</p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/stats/shots-summary/shots-summary.component.html
// module id = ./src/app/stats/shots-summary/shots-summary.component.html
// module chunks = main